module.exports = __webpack_public_path__ + "img/question-bb.0a70cdd.webp";